<template>
  <section class="content" style="padding:unset;">
    <div class="single_pro_view">
      <div class="pro_image_slider">
         <VueSlickCarousel v-bind="settings">
          <div class="iimg" v-for="image in productData.images" :key="image.id">
            <img v-bind:src='image.thumbnail'/>
          </div>
        </VueSlickCarousel>
      </div>
       <div class="pro_details">
        <div class="pro_databox">
          <p class="pc_name">{{productData == null ? "" : productData.name}}</p>
          <p class="pc_cata">Category  : {{productData == null ? "" : productData.category.name}}</p>
          <div class="pc_disc" v-html="productData.description"></div>
        </div>
      </div>
    </div>
    <div class="pro_item_table" v-for="(type, index) in typeList" :key="index">
      <p class="pro_item_table_Title">{{type.name}}</p>
      <table class="table">
        <thead class="thead_style">
          <tr>
            <th v-for="(column, index) in productData.attributes" :key="index"> {{column.name}}</th>
            <th>Colours</th>
            <th style="text-align: center;">Actions</th>
          </tr>
        </thead>
        <tbody id="customers">
          <tr v-for="(item, index) in productData.items" :key="index" v-if="item.type.id === type.id">
            <td v-for="(column, indexColumn) in productData.attributes" :key="indexColumn">{{item[column.slug]}}</td>
            <td style="width: 250px;"  v-if="item.colors.length === 1">{{item.colors[0].name}} <span class="color_dot" v-bind:style="{ backgroundColor: item.colors[0].code }"></span></td>
            <td style="width: 250px;" v-if="item.colors.length > 1">
              <div v-for="color in item.colors" v-bind:key="color.id" class="aline_cl">
                <div><md-radio class="cl_selct" :value="color.id" v-model="selectedColor[index]">{{ color.name }}</md-radio></div>
                <div><span class="color_dot" v-bind:style="{ backgroundColor: color.code }"></span></div>
              </div>
            </td>
            <td style="text-align: center;"><button type="button"  @click="addtoCart(index, item.id)" class="btn btn-cart btn-sm"><i class="fa fa-shopping-cart" aria-hidden="true"></i>&nbsp;Add to Cart</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>
<script>
  import VueSlickCarousel from 'vue-slick-carousel'
  import 'vue-slick-carousel/dist/vue-slick-carousel.css'
  // optional style for arrows & dots
  import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
  import api from '../../../api'
  export default {
    name: 'Single product',
    components: { VueSlickCarousel },
    data: () => ({
      settings: {
        'arrows': false,
        'dots': true,
        'fade': true,
        'infinite': true,
        'speed': 500,
        'slidesToShow': 1,
        'slidesToScroll': 1,
        'autoplay': true,
        'autoplaySpeed': 5000,
        // 'cssEase': 'linear',
        'centerMode': true
      },
      tableType: 1,
      productData: {},
      typeList: [],
      selectedColor: {},
      cartItem: {
        product_item_id: 0,
        product_color_id: 0,
        qty: 1
      }
    }),
    created() {
      this.getproductData()
    },
    methods: {
      viewMore(id) {
        this.$router.push('/products-view/single-product/' + id)
        location.reload()
      },
      addtoCart(index, id) {
        if (this.productData.items[index].colors.length === 1) {
          this.cartItem.product_color_id = this.productData.items[index].colors[0].id
        } else if (this.productData.items[index].colors.length > 1) {
          this.cartItem.product_color_id = this.selectedColor[index]
        }
        if (this.cartItem.product_color_id > 0) {
          this.cartItem.product_item_id = id
          api.request('post', '/admin/orders/single/create', this.cartItem)
            .then(response => {
              this.cartItem.product_item_id = 0
              this.cartItem.product_color_id = 0
              this.$root.$emit('checkCartItem')
              // eslint-disable-next-line no-undef
              toast.fire({icon: 'success', title: 'Product has been added to Cart'})
            })
        } else {
          // eslint-disable-next-line no-undef
          toast.fire({icon: 'info', title: 'Please select a colour'})
        }
      },
      getproductData() {
        api.request('get', '/admin/productcatalog/show/' + this.$route.params.id)
        .then(response => {
          this.productData = response.data.data
          const arr = []
          response.data.data.items.forEach(element => {
            arr.push({'id': element.type.id, 'name': element.type.name})
          })
          this.typeList = getUniqueListBy(arr, 'id')
          function getUniqueListBy(arr, key) {
            return [...new Map(arr.map(item => [item[key], item])).values()]
          }
          console.log(this.typeList)
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// SingleProductView.vue?5f2268b4